// @flow

import { I18n } from 'react-redux-i18n';
import { fuzzysearch } from '../../utils/fuzzysearch';
import type { Filter, ShoppingCenter } from '../../types/shoppingCenterType';


export const filterShoppingCenter =
  (shoppingCenterList: ShoppingCenter[], filters: Filter[], search: string): ShoppingCenter[] => {
    let result = true;
    for (let i = 0; i < filters.length; i++) {
      result = result && filters[i].selected.length === 0;
    }
    if (result && search === '') {
      return shoppingCenterList;
    }
    return shoppingCenterList.filter((shoppingCenter) => {
      for (let i = 0; i < filters.length; i++) {
        if (filters[i].label === filterStore &&
          !filterLabel(shoppingCenter.storeList, filters[i].selected)) {
          return false;
        }
        if (filters[i].label === filterGLA &&
          !filterGla(shoppingCenter.glaInSquareMeters, filters[i].selected)) {
          return false;
        }
        if (filters[i].label === filterVisitors &&
          !filterVisitor(shoppingCenter.yearlyVisitCount, filters[i].selected)) {
          return false;
        }
        if (filters[i].label === filterAssetFeatures &&
          !filterLabel(shoppingCenter.assetFeatures
            .map(asset => asset.label), filters[i].selected)) {
          return false;
        }
      }
      return fuzzysearch(search, shoppingCenter.name);
    });
  };

const filterLabel = (labelList: string[], selectedLabel: string[]): boolean => {
  for (let i = 0; i < selectedLabel.length; i++) {
    if (labelList.includes(selectedLabel[i])) {
      return true;
    }
  }
  return selectedLabel.length === 0;
};

const filterVisitor = (visitorCount: number, selectedFilter: string[]): boolean => {
  if (selectedFilter.length === 0) {
    return true;
  }
  if (!visitorCount) {
    return false;
  }
  if (selectedFilter.includes(vistorsInf6M) && visitorCount < 6000000) {
    return true;
  }
  if (selectedFilter.includes(vistorsBetw6MAnd10M) && visitorCount < 10000000) {
    return true;
  }
  if (selectedFilter.includes(vistorsSup10M) && visitorCount > 10000000) {
    return true;
  }
  return false;
};

const filterGla = (gla: number, selectedFilter: string[]): boolean => {
  if (selectedFilter.length === 0) {
    return true;
  }
  if (!gla) {
    return false;
  }
  if (selectedFilter.includes(glaInf6hm2) && gla < 60000) {
    return true;
  }
  if (selectedFilter.includes(glaBetw6hm2And8hm2) && gla < 80000) {
    return true;
  }
  if (selectedFilter.includes(glaSup8hm2) && gla > 80000) {
    return true;
  }
  return false;
};


export const filterStore = 'filters.STORE';
export const filterGLA = 'filters.CENTER_GLA';
export const filterVisitors = 'filters.VISITORS';
export const filterAssetFeatures = 'filters.ASSET_FEATURES';


export const initialAppliedFilters = [
  {
    label: filterStore,
    selected: [],
  },
  {
    label: filterGLA,
    selected: [],
  },
  {
    label: filterVisitors,
    selected: [],
  },
  {
    label: filterAssetFeatures,
    selected: [],
  },
];

const vistorsInf6M = '< 6 millions';
const vistorsBetw6MAnd10M = '6-10 millions';
const vistorsSup10M = '> 10 millions';

// hm2 stand for Hectometer square
const glaInf6hm2 = '< 60,000 m2';
const glaBetw6hm2And8hm2 = '60,000-80,000 m2';
const glaSup8hm2 = '> 80,000 m2';

export const shoppingCenterVisitorFilters = [vistorsInf6M, vistorsBetw6MAnd10M, vistorsSup10M];
export const shoppingCenterGLAFilters = [glaInf6hm2, glaBetw6hm2And8hm2, glaSup8hm2];
